import * as yup from 'yup';

export const deleteCredentialFormSchema = yup.object().shape({
  store_alias_id: yup.string().required('É necessário store alias id.'),
});
